"use client";
import Link from "next/link";
import React from "react";

type NavLinkProps = {
  href: string;
  children: React.ReactNode;
  variant: "navbar" | "footer";
  isActive: boolean;
  onClick?: () => void;
  className?: string;
  noPrefetch?: boolean;
};

const NavLink: React.FC<NavLinkProps> = ({
  href,
  children,
  variant,
  isActive,
  onClick,
  className = "",
  noPrefetch = false,
}) => {
  const LinkStyle = {
    navbar: `font-inter text-sm xl:text-base text-black xl:py-3 p-2 xl:px-3 2xl:px-4 mx-2 hover:bg-[#345A8C1A] no-underline hover:rounded-[10rem] hover:text-black transition-all duration-300
    ${isActive ? "bg-primary-light text-primary rounded-[10rem] font-semibold" : ""} ${className}`,
    footer: `font-inter text-sm font-normal text-white hover:underline ${className}`,
  };

  return (
    <Link href={href} className={LinkStyle[variant]} prefetch={!noPrefetch} onClick={onClick}>
      {children}
    </Link>
  );
};

export default NavLink;
